import { memo, useCallback } from 'react';

import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { OrientationFilter } from '~/components/Filters/OrientationFilter/OrientationFilter';
import { StringArrayFilterCard, type StringArrayFilterCardProps } from '~/components/Filters/StringArrayFilterCard';
import { ORIENTATION_FILTER_CARD } from '~/constants/testIDs';

export const OrientationFilterCard = memo((props: BaseFilterCardProps) => {
  const renderOrientationSelect = useCallback<StringArrayFilterCardProps['StringSelect']>(
    (props) => <OrientationFilter {...props} />,
    [],
  );

  return (
    <StringArrayFilterCard
      filter="orientations"
      filterCardType="orientation"
      StringSelect={renderOrientationSelect}
      data-testid={ORIENTATION_FILTER_CARD}
      {...props}
    />
  );
});

OrientationFilterCard.displayName = 'OrientationFilterCard';
